<template>
    <div class="row mb-2">
        <div class="col-8 fs-20 text-uppercase">{{this.name}} :</div>
        <div class="col-4 fs-20 text-end" v-text="get_price()"></div>
    </div>
</template>

<script>

import {formatCurrency} from "../../helpers/kiosk-helpers";

export default {
    name: "CartSummaryTaxes",

    components: {
    },

    data() {
        return {
        }
    },
    created(){
        this.init();
    },

    methods: {
        init()
        {
        },
        get_price(){
          return formatCurrency(this.cartTaxe.price);
        },
    },
    props: {
        cartTaxe: Object,
        name: String,
    },
}
</script>

<style scoped>

</style>
